


















import * as d3 from 'd3'
import { Component, Vue, Mixins, Prop } from 'vue-property-decorator'
import Visualization from '../../mixins/Visualization.vue'
import { Options } from '../../@types/Slide'

@Component
export default class Map extends Mixins(Visualization) {
  /**
   * Default options.
   */
  public readonly defaultChartOptions: any = {
    zoom: 6,
    backgroundColor: 'gray-400'
  }

  /**
   * Get fill color for the given feature.
   */
  public getFillColor(name: string): string {
    for (let datasetIndex in this.__data.datasets) {
      const dataset = this.__data.datasets[datasetIndex]
      const { data, backgroundColor } = dataset
      if ([data, backgroundColor].every(Array.isArray)) {
        for (let dataIndex in data) {
          if (data[dataIndex] === name) {
            return backgroundColor[dataIndex]
          }
        }
      }
    }

    return this.__options.backgroundColor
  }

  /**
   * Center of the map.
   */
  get center() {
    const [x, y] = this.geoPath.centroid(this.mainFeatured || this.geoJSON)
    return [this.width / 2 - x, this.height / 2 - y]
  }

  /**
   * Main featured country.
   */
  get mainFeatured() {
    return this.__data.datasets[0] && this.__data.datasets[0].data
      ? this.geoJSON.features.find(
          f => f.properties.name == this.__data.datasets[0].data[0]
        )
      : null
  }

  /**
   * Current geoJSON for map.
   */
  get geoJSON(): any {
    return require(`@/assets/${this.__options.map}.json`)
  }

  /**
   * Projection used for the map.
   */
  get projection(): any {
    return d3
      .geoMercator()
      .fitSize(
        [this.width * this.__options.zoom, this.height * this.__options.zoom],
        this.geoJSON
      )
      .translate([this.width / 2, this.height / 2])
      .center(d3.geoCentroid(this.geoJSON))
  }

  /**
   * Geopath.
   */
  get geoPath(): any {
    return d3.geoPath().projection(this.projection)
  }
}
